$(function () {
    var types = [];
    var prefs = [];
    var ages = [];
    var requestPref = $('body input[name=pref]:radio:checked').val();

    if (requestPref && requestPref !== 'all') {
        $('body .pref-' + requestPref).show();

        $('body .regions').show();
    }

    var $fancySelect = $('[data-fancyform="select"]').select2({
        minimumResultsForSearch: Infinity,
        width: Infinity
    });

    $('[data-id="filter-switch"]').on('click touched', function () {
        $('[data-id="selector"]').slideToggle();

        var filterFixed = $('.pages__filter').hasClass('fixedTop');

        if (filterFixed === true) {
            $('.pages__filter').removeClass('fixedTop');
        }

        var $parent = $(this).closest('[data-id="filter-group"]');

        var $self_children = $(this).next('[data-id="filter-content"]');

        $siblings = $parent.siblings();

        $other_children = $siblings.find('[data-id="filter-content"]');

        $parent.toggleClass('on');

        $self_children.slideToggle();

        $siblings.removeClass('on');

        $other_children.slideUp();
    });

    $('body')
        .on('click', '.reset-button', function () {
            $('body .form')[0].reset();

            var form = $('body .form');

            form.find('input:checkbox, input:radio').prop('checked', false);

            form.find('input[type=hidden], input[type=text]').val('');

            form.find('select').val('').trigger('change');

            form.find('input[name=order]').val($('body select[id=sort-select]').val());

            $('body .regions, body .prefs').hide();

            // $('body .prefs').hide();
        })
        .on('change', '.prefs-radio', function () {
            $('body .prefs').hide().find('input:checkbox').prop('checked', false);

            $('body input[name=cities]').val('');

            var regions = $('body .regions');
            var prefId = $('body input[name=pref]:radio:checked').val();

            if (prefId === 'all') {
                regions.hide('slow');

                return;
            }

            if (regions.is(':hidden')) {
                regions.show();
            }

            $('body .pref-' + prefId).show('normal');
        })
        .on('change', '.prefs', function () {
            prefs = [];

            $('body .prefs').find('input:checkbox:checked').map(function () {
                prefs.push($(this).val());
            });

            $('body input[name=cities]').val(prefs);
        })
        .on('change', '.types', function () {
            types = [];

            $('body .types').find('input:checkbox:checked').map(function () {
                types.push($(this).val());
            });

            $('body input[name=types]').val(types);
        })
        .on('change', 'select[name=low_price]', function () {
            if (!!parseInt($(this).val())) {
                $('body input[name=min_price]').val('');

                $('body input[name=max_price]').val('');
            }

            var highPrice = parseInt($('body select[name=high_price]').val());

            if (!!highPrice) {
                if (parseInt($(this).val()) > highPrice) {

                    alert($('body .price-range').data('price-warning'));

                    $(this).val('').trigger('change');
                }
            }
        })
        .on('change', 'select[name=high_price]', function () {
            if (!!parseInt($(this).val())) {
                $('body input[name=min_price]').val('');

                $('body input[name=max_price]').val('');
            }

            var lowPrice = parseInt($('body select[name=low_price]').val());

            if (!!lowPrice) {
                if (parseInt($(this).val()) < lowPrice) {

                    alert($('body .price-range').data('price-warning'));

                    $(this).val('').trigger('change');
                }
            }
        })
        .on('blur', 'input[name=min_price]', function () {
            var maxPrice = parseInt($('body input[name=max_price]').val());

            if (!!maxPrice) {
                if (parseInt($(this).val()) > maxPrice) {

                    alert($('body .price-range').data('price-warning'));

                    $(this).val('');
                }
            }
        })
        .on('blur', 'input[name=max_price]', function () {
            var minPrice = parseInt($('body input[name=min_price]').val());

            if (!!minPrice) {
                if (parseInt($(this).val()) < minPrice) {

                    alert($('body .price-range').data('price-warning'));

                    $(this).val('');
                }
            }
        })
        .on('keyup', 'input[name=min_price],input[name=max_price]', function () {
            $(this).val(formatNumber($(this).val()));

            $('body select[name=low_price]').val('').trigger('change');

            $('body select[name=high_price]').val('').trigger('change');
        })
        .on('paste', 'input[name=min_price],input[name=max_price]', function () {
            $(this).val(formatNumber($(this).val()));

            $('body select[name=low_price]').val('').trigger('change');

            $('body select[name=high_price]').val('').trigger('change');
        })
        .on('change', 'select[name=low_area]', function () {
            if (!!parseInt($(this).val())) {
                $('body input[name=min_area]').val('');

                $('body input[name=max_area]').val('');
            }

            var highArea = parseInt($('body select[name=high_area]').val());

            if (!!highArea) {
                if (parseInt($(this).val()) > highArea) {

                    alert($('body .area-range').data('area-warning'));

                    $(this).val('').trigger('change');
                }
            }
        })
        .on('change', 'select[name=high_area]', function () {
            if (!!parseInt($(this).val())) {
                $('body input[name=min_area]').val('');

                $('body input[name=max_area]').val('');
            }

            var lowArea = parseInt($('body select[name=low_area]').val());

            if (!!lowArea) {
                if (parseInt($(this).val()) < lowArea) {

                    alert($('body .area-range').data('area-warning'));

                    $(this).val('').trigger('change');
                }
            }
        })
        .on('blur', 'input[name=min_area]', function () {
            var maxArea = parseInt($('body input[name=max_area]').val());

            if (!!maxArea) {
                if (parseInt($(this).val()) > maxArea) {

                    alert($('body .area-range').data('area-warning'));

                    $(this).val('');
                }
            }
        })
        .on('blur', 'input[name=max_area]', function () {
            var minArea = parseInt($('body input[name=min_area]').val());

            if (!!minArea) {
                if (parseInt($(this).val()) < minArea) {

                    alert($('body .area-range').data('area-warning'));

                    $(this).val('');
                }
            }
        })
        .on('keyup', 'input[name=min_area],input[name=max_area]', function () {
            $(this).val(formatNumber($(this).val()));

            $('body select[name=low_area]').val('').trigger('change');

            $('body select[name=high_area]').val('').trigger('change');
        })
        .on('paste', 'input[name=min_area],input[name=max_area]', function () {
            $(this).val(formatNumber($(this).val()));

            $('body select[name=low_area]').val('').trigger('change');

            $('body select[name=high_area]').val('').trigger('change');
        })
        .on('change', 'select[name=low_floor]', function () {
            var highFloor = parseInt($('body select[name=high_floor]').val());

            if (!!highFloor) {
                if (parseInt($(this).val()) > highFloor) {

                    alert($('body .floor-range').data('floor-warning'));

                    $(this).val('').trigger('change');
                }
            }
        })
        .on('change', 'select[name=high_floor]', function () {
            var lowFloor = parseInt($('body select[name=low_floor]').val());

            if (!!lowFloor) {
                if (parseInt($(this).val()) < lowFloor) {

                    alert($('body .floor-range').data('floor-warning'));

                    $(this).val('').trigger('change');
                }
            }
        })
        .on('change', '.ages', function () {
            ages = [];

            $('body .ages').find('input:checkbox:checked').map(function () {
                ages.push($(this).val());
            });

            if (!!ages.length) {
                $('body input[name=min_age]').val('');

                $('body input[name=max_age]').val('');
            }

            $('body input[name=ages]').val(ages);
        })
        .on('blur', 'input[name=min_age]', function () {
            var maxAge = parseInt($('body input[name=max_age]').val());

            if (!!maxAge) {
                if (parseInt($(this).val()) > maxAge) {

                    alert($('body .age-range').data('age-warning'));

                    $(this).val('');
                }
            }
        })
        .on('blur', 'input[name=max_age]', function () {
            var minAge = parseInt($('body input[name=min_age]').val());

            if (!!minAge) {
                if (parseInt($(this).val()) < minAge) {

                    alert($('body .age-range').data('age-warning'));

                    $(this).val('');
                }
            }
        })
        .on('keyup', 'input[name=min_age],input[name=max_age]', function () {
            $(this).val(formatNumber($(this).val(), 0, 4));

            $('body .ages').find('input:checkbox').prop('checked', false);
        })
        .on('paste', 'input[name=min_age],input[name=max_age]', function () {
            $(this).val(formatNumber($(this).val(), 0, 4));

            $('body .ages').find('input:checkbox').prop('checked', false);
        })
        .on('change', '#sort-select', function () {
            $('body input[name=order]').val($(this).val());

            queryHandle();
        })
        .on('submit', '.form', function (event) {
            event.preventDefault();

            queryHandle();
        });

    function formatNumber(number, from = 0, length = 10) {
        var value = number.replace(/\b(0+)/g, '');

        return value.replace(/[^\d]/g, '').substr(from, length);
    }

    function queryHandle() {
        var queryArray = {};

        $.each($('body .form').serializeArray(), function (index, item) {
            if (!! item.value) {
                queryArray[item.name] = item.value;
            }
        });

        location.href = location.protocol + '//' + location.hostname + location.pathname + '?' + $.param(queryArray);
    }
});
